import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAA1LXsf7DT7rIYz1YXsIPwzBzgVl2NW2w',
  authDomain: 'linker-81a76.firebaseapp.com',
  projectId: 'linker-81a76',
  storageBucket: 'linker-81a76.firebasestorage.app',
  messagingSenderId: '758799929868',
  appId: '1:758799929868:web:3e794fcc7e7bc71cbb1429',
  measurementId: 'G-YGYN3Z755F'
};

export const app = initializeApp(firebaseConfig);

isSupported()
  .then((supported) => {
    if (supported) {
      getAnalytics(app);
    }
  })
  .catch(() => {
    // Analytics unsupported in this environment.
  });

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
